/* eslint-disable @typescript-eslint/no-unused-expressions */
import React, { FormEvent, useState } from "react";
import { useIntl } from 'react-intl';
import { VALIDATOR_EMAIL, VALIDATOR_REQUIRE, VALIDATOR_MINLENGTH, VALIDATOR_MAXLENGTH, VALIDATOR_PASSWORD } from '../../utils/validators';
import { useForm } from '../../hooks/form-hook';
import PrimaryButton from "../../components/FormElements/PrimaryButton";
import InputForm from '../../components/FormElements/InputForm';
import Logo from "../../assets/image/logo.svg";
import { Form, DivLogo, DivButtons, DivInput, Arrow, PhoneInputStyled, Label, TextConfirm, Container, Icon, Content, Title, Subtitle, Arrow2, TextNewPlatform, ColorInput, Small } from "./styles";
import { getPreviousUser, loadCompanyById, signupRecoverUser } from "../../services/index";
import { toast } from 'react-toastify';
import PhoneInput from 'react-phone-number-input';
import { useNavigate } from "react-router-dom";
import { UserConfigs, db } from "../../db/db";
import { AiOutlineLeft } from "react-icons/ai";
import { useLiveQuery } from "dexie-react-hooks";
import Loading from "../../components/Loading";
import rede from '../../assets/image/rede.svg';
import empresa from '../../assets/image/empresa.svg';
import { getCurrentDateTimezone } from "../../utils/formatDateHour";

interface Props {
  userConfigsDB?: UserConfigs
};

const RecoverAccountPage = ({ userConfigsDB }: Props) => {
  const intl = useIntl();
  const userConfigDb = useLiveQuery(() => db.userConfigs.toArray());
  const [country, setCountry] = useState<any>();
  const [phone, setPhone] = useState<any>();
  const [previousCompany, setPreviousCompany] = useState<string>();
  const [userType, setUserType] = useState<string>('adm');
  const [isLoading, setIsLoading] = useState(false);
  const [showIDInput, setShowIDInput] = useState<boolean>(false);
  const [errorPhone, setErrorPhone] = useState<boolean>(false);
  const navigate = useNavigate();
  let emailRequest = getQueryVariable('email');
  let nameRequest = getQueryVariable('name');
  let page = getQueryVariable('page');

  if (nameRequest && emailRequest) {
    localStorage.setItem('name', nameRequest);
    localStorage.setItem('email', emailRequest);
  }
  const savedName = localStorage.getItem('name');
  const savedEmail = localStorage.getItem('email');

  const [previousUserName, setPreviousUserName] = useState<string>(savedName ? savedName : '');
  const [previousEmail, setPreviousEmail] = useState<string>(savedEmail ? savedEmail : '');
  const [showInfo, setShowInfo] = useState<string>(page === 'RECOVER' ? 'RECOVER' : nameRequest && emailRequest ? "COMPANY" : "EMAIL");

  function getQueryVariable(variable: string) {
    var query = window.location.search.substring(1);
    var vars = query.split("&");

    for (var i = 0; i < vars.length; i++) {
      var pair = vars[i].split("=");
      if (pair[0] === variable) { return decodeURI(pair[1]); }
    }
    return (false);
  }

  const [formState, inputHandler] = useForm(
    {
      companyName: {
        value: '',
        isValid: false,
      },
      email: {
        value: '',
        isValid: false,
      },
      userName: {
        value: '',
        isValid: false,
      },
      password: {
        value: '',
        isValid: false,
      },
      passwordConfirm: {
        value: '',
        isValid: false,
      }
    },
    false
  );

  const handlePreviousUser = (event: FormEvent) => {
    event.preventDefault();
    setIsLoading(true)
    try {
      getPreviousUser(formState.inputs.email.value)
        .then(resp => {
          const response = resp.data.user;
          if (resp.data === 'existing account') {
            toast.error(intl.formatMessage({ id: 'register.E-mail já cadastrado na plataforma. Informe um novo e-mail ou acesse a plataforma com o e-mail já cadastrado' }).toUpperCase());
            setIsLoading(false)
          }
          else if (response === undefined) {
            toast.error(intl.formatMessage({ id: 'register.E-mail não encontrado' }).toUpperCase());
            setIsLoading(false)
          } else {
            setPreviousUserName(response.nome_usuario)
            setPreviousEmail(response.email)
            setShowInfo('CONFIRMATION')
            setIsLoading(false)
          }
        })
        .catch(error => {
          toast.error(intl.formatMessage({ id: 'register.Digite seu e-mail da plataforma IOK antiga' }).toUpperCase());
          setIsLoading(false)
        })
    } catch (error) {
      toast.error(intl.formatMessage({ id: 'register.Não foi possível recuperar seus dados. Verifique e tente novamente' }).toUpperCase());
      setIsLoading(false)
    }
  };

  const handleBack = (showInfo: string) => {
    switch (showInfo) {
      case "EMAIL":
        return navigate('/login');
      case "RECOVER":
        return userType === 'adm' ? navigate('/entity?page=RECOVER') : setShowInfo("COMPANY");
      case "CONFIRMATION":
        return navigate('/login');
      case "COMPANY":
        return setShowInfo("EMAIL");
      case "ADMCONFIRMATION":
        return navigate('/login');
      case "USERCONFIRMATION":
        return navigate('/login');
    }
  };


  const handleSubmitRecover = () => {
    if (!formState.isValid || !phone) {
      if (!phone) setErrorPhone(true)
      toast.error(intl.formatMessage({ id: 'menus.Existem campos com informações inválidas' }).toUpperCase());
      return;
    }
    if (formState.inputs.password.value !== formState.inputs.passwordConfirm.value) {
      toast.error(intl.formatMessage({ id: 'register.As senhas devem ser iguais' }).toUpperCase());
      return;
    }
    try {
      const signupUser = {
        user: {
          userName: formState.inputs.userName.value,
          email: formState.inputs.email.value,
          phone: phone,
          creationDate: getCurrentDateTimezone(),
          password: formState.inputs.password.value,
          passwordConfirmation: formState.inputs.passwordConfirm.value,
          language: userConfigDb ? userConfigDb[0].language : 'EN',
        },
        company: {
          corporateName: formState.inputs.companyName.value,
          companyType: userConfigDb ? userConfigDb[0].companyTypeId : 'Dono'
        },
        userType: userType
      };
      setIsLoading(true);
      signupRecoverUser(signupUser)
        .then(resp => {
          setIsLoading(false)
          setShowInfo(userType === 'adm' ? "ADMCONFIRMATION" : "USERCONFIRMATION")
        })
        .catch(error => {
          console.error(error.response.data.error)
          if (error.response.data.error === 'This company has already been registered')
            toast.error(intl.formatMessage({ id: 'register.Empresa já cadastrada na plataforma. Por favor, informe o nome de uma nova empresa' }).toUpperCase())
          else if (error.response.data.error.includes('Missing param'))
            toast.error(intl.formatMessage({ id: 'menus.Existem campos que não foram preenchidos' }).toUpperCase())
          else
            toast.error(intl.formatMessage({ id: 'register.Não foi possível fazer o cadastro. Verifique seus dados e tente novamente' }).toUpperCase())
        })
        .finally(() => {
          setIsLoading(false);
        })
    } catch (error) {
      toast.error(intl.formatMessage({ id: 'register.Não foi possível fazer o cadastro. Verifique seus dados e tente novamente' }).toUpperCase());
    }
  };

  const handleConfirmationCompany = async (event: FormEvent) => {
    event.preventDefault()
    try {
      loadCompanyById(formState.inputs.idCompany.value)
        .then(resp => {
          const response = resp.data.company
          if (response === undefined) {
            toast.error(intl.formatMessage({ id: 'register.ID informado não corresponde a nenhuma companhia. Verifique e tente novamente' }).toUpperCase());
          } else {
            setPreviousCompany(response.corporateName)
            setUserType('cli')
            setShowInfo('RECOVER')
          }
        })
    } catch (error) {
      console.error(error)
    }
  };

  const idendityConfirm = (
    <>
      <TextConfirm>
        {intl.formatMessage({ id: "recoverPassword.EM BREVE VOCÊ RECEBERÁ UM E-MAIL PARA CONFIRMAR SUA IDENTIDADE" })}
      </TextConfirm>
    </>
  );

  const userConfirmation = (
    <>
      <TextConfirm>
        {intl.formatMessage({ id: "register.O ADMINISTRADOR DA ORGANIZAÇÃO RECEBERÁ UM E-MAIL PARA ATIVAR SUA CONTA. POR GENTILIZA, AGUARDE" })}
      </TextConfirm>
    </>
  );

  const admConfirmation = (
    <>
      <TextConfirm>
        {intl.formatMessage({ id: "register.VOCÊ RECEBERÁ UM E-MAIL PARA CONCLUIR SEU CADASTRO E ATIVAR SUA CONTA DE ADMINISTRADOR" })}
      </TextConfirm>
    </>
  );

  const email = (
    <>
      <Form onSubmit={handlePreviousUser} autoComplete="off">
        <DivInput>
          <InputForm
            id='email'
            type='email'
            initialValue={formState.inputs.email ? formState.inputs.email.value : ''}
            label={intl.formatMessage({ id: 'register.E-mail' })  + ' *'}
            validators={[VALIDATOR_EMAIL()]}
            placeholder={intl.formatMessage({ id: 'register.Informe seu e-mail cadastrado na plataforma IOK anterior' })}
            errorText={intl.formatMessage({ id: 'register.E-mail inválido. Por favor, verifique' })}
            onInput={inputHandler}
            isLogin
          />
        </DivInput>
        <DivButtons>
          <PrimaryButton type='submit' size='extra-large' model='white-outline' width='276px' onClick={() => handlePreviousUser(formState.inputs.email.value)}>
            {intl.formatMessage({ id: 'register.CONFIRMAR' })}
          </PrimaryButton>
        </DivButtons>
      </Form>
    </>
  );

  const recover = (
    <>
      <Form autoComplete="off">
        <DivInput>
          <InputForm
            id='companyName'
            type='text'
            label={intl.formatMessage({ id: 'register.Nome da organização' })}
            validators={[VALIDATOR_REQUIRE(), VALIDATOR_MAXLENGTH(14)]}
            maxLength={14}
            placeholder={intl.formatMessage({ id: 'register.Informe o nome de sua organização' })}
            errorText={intl.formatMessage({ id: 'register.O campo nome da organização é obrigatório' })}
            onInput={inputHandler}
            initialValid={previousCompany == ('' || undefined) ? formState.inputs.password ? true : false : true}
            initialValue={previousCompany !== '' && previousCompany !== undefined ? previousCompany : formState.inputs.companyName.value !== '' ? formState.inputs.companyName.value : ''}
            isLogin
          />
        </DivInput>
        <DivInput>
          <InputForm
            id='userName'
            type='text'
            initialValid
            initialValue={previousUserName}
            label={intl.formatMessage({ id: 'register.Nome' })}
            validators={[VALIDATOR_REQUIRE()]}
            placeholder={intl.formatMessage({ id: 'register.Informe seu nome' })}
            errorText={intl.formatMessage({ id: 'register.O campo nome é obrigatório' })}
            onInput={inputHandler}
            isLogin
          />

        </DivInput>
        <DivInput>
          <InputForm
            id='email'
            type='email'
            initialValid
            initialValue={previousEmail}
            label={intl.formatMessage({ id: 'register.E-mail' })}
            validators={[VALIDATOR_EMAIL()]}
            placeholder={intl.formatMessage({ id: 'register.Informe seu e-mail' })}
            errorText={intl.formatMessage({ id: 'register.E-mail inválido. Por favor, verifique novamente' })}
            onInput={inputHandler}
            isLogin
          />
          <PhoneInputStyled>
            <Label>{intl.formatMessage({ id: 'register.Telefone' })}</Label>
            <PhoneInput
              id='phone'
              placeholder='+55 (    ) __________ ________'
              international
              value={phone}
              onCountryChange={setCountry}
              onChange={setPhone}
              limitMaxLength={true}
            />
            {errorPhone && !phone &&
              <Small>
                {intl.formatMessage({ id: 'user.Informe o telefone do usuário' })}
              </Small>
            }
          </PhoneInputStyled>
        </DivInput>

        <DivInput>
          <InputForm
            id='password'
            type='password'
            initialValid={formState.inputs.password ? true : false}
            initialValue={formState.inputs.password ? formState.inputs.password.value : ''}
            label={intl.formatMessage({ id: 'register.Crie sua senha' })}
            placeholder={intl.formatMessage({ id: 'register.Informe sua senha' })}
            validators={[VALIDATOR_MINLENGTH(8), VALIDATOR_MAXLENGTH(20), VALIDATOR_PASSWORD()]}
            errorText={intl.formatMessage({ id: 'register.Sua senha deve estar entre 8 e 20 caracteres, ter uma letra maiúscula, uma minúscula, um número e um caractere especial' })}
            onInput={inputHandler}
            isLogin
          />
          <InputForm
            id='passwordConfirm'
            type='password'
            initialValid={formState.inputs.passwordConfirm ? true : false}
            initialValue={formState.inputs.passwordConfirm ? formState.inputs.passwordConfirm.value : ''}
            label={intl.formatMessage({ id: 'register.Confirme sua senha' })}
            placeholder={intl.formatMessage({ id: 'register.Informe sua senha' })}
            validators={[VALIDATOR_MINLENGTH(8), VALIDATOR_MAXLENGTH(20), VALIDATOR_PASSWORD()]}
            errorText={intl.formatMessage({ id: 'register.As senhas devem ser iguais' })}
            onInput={inputHandler}
            isLogin
          />
        </DivInput>

        <DivButtons>
          <PrimaryButton type='button' size='extra-large' model='white-outline' width='276px' onClick={handleSubmitRecover}>
            {intl.formatMessage({ id: 'register.RECUPERAR CONTA' })}
          </PrimaryButton>
        </DivButtons>
      </Form>
    </>
  );

  const company = (
    <>
      <Form onSubmit={handleConfirmationCompany}>
        <TextNewPlatform>
          {intl.formatMessage({ id: "register.A nova plataforma IOK agora conta com novas formas de acesso - que são referentes ao tipo de organização em que você atua. O responsável pela sua organização deve migrar a conta principal da empresa, se tornando o administrador, enquanto o restante dos funcionários devem se vincular a ela pelo ID fornecido." })}
        </TextNewPlatform>
        <Container onClick={() => setShowIDInput(true)}>
          <Icon>
            <img src={rede} alt='icon'></img>
          </Icon>
          <Content>
            <Title className="title">
              {intl.formatMessage({ id: "register.Conta da organização já migrada" })}
            </Title>
            <Subtitle>
              {intl.formatMessage({ id: "register.O administrador da minha organização já realizou a migração da conta e temos um ID. Desejo migrar meus dados de usuário." })}
            </Subtitle>
            {showIDInput &&
              <>
                <ColorInput>
                  <InputForm
                    id='idCompany'
                    type='number'
                    initialValid
                    validators={[VALIDATOR_REQUIRE()]}
                    placeholder={intl.formatMessage({ id: 'register.Informe o ID da organização' })}
                    errorText={intl.formatMessage({ id: 'register.O campo com ID é obrigatório' })}
                    onInput={inputHandler}
                    isLogin
                  />
                  <PrimaryButton type='submit' size='large' model='confirmation-solid' width='200px'>
                    {intl.formatMessage({ id: 'register.CONFIRMAR' })}
                  </PrimaryButton>
                </ColorInput>
              </>
            }
          </Content>
        </Container>

        <Container onClick={() => navigate('/entity?page=RECOVER')}>
          <Icon>
            <img src={empresa} alt='icon'></img>
          </Icon>
          <Content>
            <Title className="title">
              {intl.formatMessage({ id: "register.Migrar conta da organização" })}
            </Title>
            <Subtitle>
              {intl.formatMessage({ id: "register.Desejo migrar a conta da minha organização e me tornar o administrador." })}
            </Subtitle>
          </Content>
          <Arrow2 className="arrow">
            <AiOutlineLeft className="small" />
            <AiOutlineLeft className="big" />
          </Arrow2>
        </Container>
      </Form>
    </>
  );

  return (
    <>
      {isLoading && <Loading />}
      {!isLoading && (
        <div>
          <Arrow><AiOutlineLeft onClick={(e) => handleBack(showInfo)} /></Arrow>
          <DivLogo>
            <img src={Logo} alt='Logo' />
          </DivLogo>
          {showInfo === "EMAIL" && email}
          {showInfo === "CONFIRMATION" && idendityConfirm}
          {showInfo === "COMPANY" && company}
          {showInfo === "RECOVER" && recover}
          {showInfo === "USERCONFIRMATION" && userConfirmation}
          {showInfo === "ADMCONFIRMATION" && admConfirmation}
        </div>
      )}
    </>
  );
};

export default RecoverAccountPage;
